import { Injectable } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';

@Injectable()
export class DataFormat {

  private static locale = 'hu-HU';
  private static fileSizeSuffixes = ['B', 'kB', 'MB', 'GB', 'TB'];

  public asDate(value: string): string {
    if (!value) { return ''; }

    const date = new Date(value);
    return date.toLocaleDateString(DataFormat.locale);
  }

  public asDateTime(value: string): string {
    if (!value) { return ''; }

    const date = new Date(value);
    if (date.getFullYear() === 1) { return ''; }

    return date.toLocaleDateString(DataFormat.locale) + ' ' + date.toLocaleTimeString(DataFormat.locale);
  }

  public asFileSize(value: string): string {
    if (!value) { return '0 B'; }

    const size = parseInt(value, 10);
    if (isNaN(size) || size < 0) { return '0 B'; }

    const l10 = Math.log10(size);
    const index = (isFinite(l10)) ? Math.floor(l10 / 3) : 0;
    const exp = index * 3;
    const divider = Math.pow(10, exp);

    return (size / divider).toFixed(1) + ' ' + DataFormat.fileSizeSuffixes[index];
  }
}

@Pipe({ name: 'asDate' })
export class DatePipe implements PipeTransform {
  df = new DataFormat();

  transform(value: any): string {
    return this.df.asDate(value);
  }

}

@Pipe({ name: 'asDateTime' })
export class DateTimePipe implements PipeTransform {
  df = new DataFormat();

  transform(value: any): string {
    return this.df.asDateTime(value);
  }
}

@Pipe({ name: 'asFileSize' })
export class FileSizePipe implements PipeTransform {
  df = new DataFormat();

  transform(value: any): string {
    return this.df.asFileSize(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/data.formatters.ts